export const ROOT = '/';
export const LOGIN = '/login';
export const NEWS = '/news_info';
export const INFORMATIONS = '/informations';
